module.exports = __webpack_public_path__ + "img/Flip Card 2.28074635.svg";